(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["estadisticas"] && !Shopify.designMode) return;
  try {
    
(function() {
  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function animarNumero(el, objetivo, duracion) {
    var inicio = null;
    function paso(tiempo) {
      if (!inicio) inicio = tiempo;
      var progreso = Math.min((tiempo - inicio) / duracion, 1);
      var ease = easeOutCubic(progreso);
      el.textContent = Math.floor(ease * objetivo);
      if (progreso < 1) {
        requestAnimationFrame(paso);
      } else {
        el.textContent = objetivo;
      }
    }
    requestAnimationFrame(paso);
  }

  function animarCirculo(circulo, porcentaje, duracion) {
    var circunferencia = 150.796;
    var offsetFinal = circunferencia * (1 - porcentaje / 100);
    var inicio = null;
    function paso(tiempo) {
      if (!inicio) inicio = tiempo;
      var progreso = Math.min((tiempo - inicio) / duracion, 1);
      var ease = easeOutCubic(progreso);
      var offsetActual = circunferencia - (ease * (circunferencia - offsetFinal));
      circulo.style.strokeDashoffset = offsetActual;
      if (progreso < 1) {
        requestAnimationFrame(paso);
      } else {
        circulo.style.strokeDashoffset = offsetFinal;
      }
    }
    requestAnimationFrame(paso);
  }

  function iniciarEstadisticas() {
    var seccion = document.querySelector('.estadisticas__seccion');
    if (!seccion) return;

    var duracion = parseInt(seccion.dataset.duracion) || 1500;
    var items = seccion.querySelectorAll('.estadisticas__item');

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && !entry.target.dataset.animado) {
          entry.target.dataset.animado = '1';
          var numEl = entry.target.querySelector('.estadisticas__numero');
          var circEl = entry.target.querySelector('.estadisticas__circulo-progreso');
          if (numEl && circEl) {
            var objetivo = parseInt(numEl.dataset.target) || 0;
            animarNumero(numEl, objetivo, duracion);
            animarCirculo(circEl, objetivo, duracion);
          }
        }
      });
    }, { threshold: 0.4 });

    items.forEach(function(item) {
      observer.observe(item);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarEstadisticas);
  } else {
    iniciarEstadisticas();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
(function() {
  function iniciarResenas() {
    var botones = document.querySelectorAll('[id^="resenas-boton-"]');

    botones.forEach(function(boton) {
      var seccionId = boton.dataset.section;
      var grid = document.getElementById('resenas-grid-' + seccionId);
      var botonWrap = document.getElementById('resenas-boton-wrap-' + seccionId);
      var textoVer = boton.dataset.textoVer;
      var textoOcultar = boton.dataset.textoOcultar;
      var expandido = false;

      if (!grid) return;

      var ocultas = grid.querySelectorAll('.resenas__tarjeta--oculta');
      if (ocultas.length === 0) {
        botonWrap.style.display = 'none';
        return;
      }

      boton.addEventListener('click', function() {
        if (!expandido) {
          ocultas.forEach(function(tarjeta, i) {
            tarjeta.classList.remove('resenas__tarjeta--oculta');
            tarjeta.style.animationDelay = (i * 0.06) + 's';
            tarjeta.classList.add('resenas__tarjeta--animando');
          });
          expandido = true;
          if (textoOcultar && textoOcultar !== '') {
            boton.textContent = textoOcultar;
          } else {
            botonWrap.style.display = 'none';
          }
        } else {
          ocultas.forEach(function(tarjeta) {
            tarjeta.classList.add('resenas__tarjeta--oculta');
            tarjeta.classList.remove('resenas__tarjeta--animando');
          });
          expandido = false;
          boton.textContent = textoVer;
          grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarResenas);
  } else {
    iniciarResenas();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
